import { Star } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials() {
  return (
    <section id="temoignages" className="py-16 md:py-24 lg:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          eyebrow="Témoignages"
          title="Ce que disent les membres."
          sub="La parole à la communauté."
          align="center"
        />
        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-testid="testimonials-grid">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 0.1} className="h-full">
              <figure
                className="relative flex h-full flex-col rounded-2xl border border-border bg-card p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-gold/50"
                data-testid={`testimonial-card-${i + 1}`}
              >
                <span className="absolute right-6 top-6 rounded border border-border px-2 py-0.5 font-mono text-[9px] uppercase tracking-widest text-muted-foreground/70" data-testid={`testimonial-example-badge-${i + 1}`}>
                  Exemple
                </span>
                <div className="flex gap-1" aria-label="5 étoiles">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4 text-gold" fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <blockquote className="mt-5 flex-1">
                  <p className="font-serif text-lg italic leading-relaxed text-foreground/90">"{t.quote}"</p>
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-4 border-t border-border pt-6">
                  <img src={t.img} alt="" className="h-12 w-12 rounded-full border-2 border-gold/40 object-cover" loading="lazy" />
                  <div>
                    <p className="text-sm font-bold text-foreground">{t.name}</p>
                    <p className="text-xs text-muted-foreground">{t.job}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        <p className="mt-8 text-center text-xs text-muted-foreground">
          Témoignages fictifs présentés comme exemples — ils seront remplacés par de vrais avis de membres.
        </p>
      </div>
    </section>
  );
}
